module.exports = __webpack_public_path__ + "img/wait.08fc88d3.png";